import { gql } from 'apollo-angular';

export class blogNewsMutations {
    public static blogNewsUpdatePost = gql`
        mutation blogNewsUpdatePost($postId: String!, $post: String!, $accepted: Boolean!, $issueLabels: String!, $archived: Boolean!, $issueKey: String) {
            blogNewsUpdatePost(postId: $postId, post: $post, accepted: $accepted, issueLabels: $issueLabels, archived: $archived, issueKey: $issueKey)
        }
    `;
}


